import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { DialogsService } from '../../../core/services/dialog.service';
import { UploadDAO } from '../../../core/services/dao/uploadDAO';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { ConstantMan } from '../../../core/services/constantMan';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FileListComponent implements OnInit {
  @Input() files: string[];

  @Input() paramId: number;

  @Input() keyPrefix: string;

  @Input() vesselForm: boolean;

  @Input() disabled: boolean;

  @Input() s3path: string;

  @Input() userId: number;

  @Input() maxFiles: number;

  @Output() filesChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  public fileError: string = '';

  private bucket: string;

  constructor(public dialog: DialogsService, public uploadDAO: UploadDAO) {
    switch (environment.envName) {
      case 'local':
        this.bucket = ConstantMan.BUCKETS.LOCAL;
        break;
      case 'local-like-production':
        this.bucket = ConstantMan.BUCKETS.LOCAL;
        break;
      case 'dev':
        this.bucket = ConstantMan.BUCKETS.DEV;
        break;
      case 'stage':
        this.bucket = ConstantMan.BUCKETS.STAGE;
        break;
      case 'prod':
        this.bucket = ConstantMan.BUCKETS.PROD;
        break;
      default:
        this.bucket = ConstantMan.BUCKETS.DEV;
        break;
    }
  }

  ngOnInit() {}

  delete(index: number) {
    let ref = this.dialog.DeleteDialog(this.files[index]);
    ref.subscribe((result) => {
      if (result) {
        console.log(this.paramId);
        if (!this.vesselForm) {
          this.uploadDAO
            .delete(this.files[index], this.paramId, this.s3path)
            .subscribe(
              (result) => {
                this.files.splice(index, 1);
                this.filesChange.emit(this.files);
              },
              (err) => {
                console.error(err);
              },
            );
        } else {
          this.uploadDAO
            .deleteVesselFile(this.files[index], this.paramId, this.s3path)
            .subscribe(
              (result) => {
                console.log(result);
                this.files.splice(index, 1);
                this.filesChange.emit(this.files);
              },
              (err) => {
                console.error(err);
              },
            );
        }
      }
    });
  }

  dataURLtoBlob(dataurl: string) {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  resize(
    input: File,
    max: number,
    name: string,
    quality: number,
  ): Promise<File> {
    const reader = new FileReader();
    return new Promise<File>((resolve) => {
      reader.onload = (readerEvent: any) => {
        let image = new Image();
        image.onload = () => {
          let canvas = document.createElement('canvas');
          canvas.style.display = 'none';
          let width = image.width;
          let height = image.height;
          if (width > height) {
            if (width > max) {
              height *= max / width;
              width = max;
            }
          } else {
            if (height > max) {
              width *= max / height;
              height = max;
            }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);
          let url = canvas.toDataURL('image/jpeg', quality);
          let resized = this.dataURLtoBlob(url);
          resolve(new File([resized], name, { type: 'image/jpg' }));
        };
        image.src = readerEvent.target.result;
      };
      reader.readAsDataURL(input);
    });
  }

  fileChange(event: any) {
    if (
      this.maxFiles &&
      this.files.length + event.target.files.length > this.maxFiles
    ) {
      this.fileError = 'You may only upload ' + this.maxFiles + ' files.';
    } else {
      let files = event.target.files;
      for (let i = 0; i < files.length; ++i) {
        let name = files.item(i).name;
        let thumbName = '';
        let ext = name.split('.').pop().toLowerCase();
        let time = moment().unix().toString();
        if (files.item(i).name === 'image.jpg') {
          name = time + '.jpg';
          thumbName = time + '.thumb';
        }
        if (ext === 'pdf' || ext === 'png' || ext === 'jpg' || ext === 'jpeg') {
          if (ext !== 'pdf') {
            this.resize(files.item(i), 1440, 'image.jpg', 0.3).then(
              (resized) => {
                if (!this.vesselForm) {
                  this.uploadDAO
                    .uploadFileSecure(
                      resized,
                      resized.name,
                      this.paramId,
                      this.s3path,
                    )
                    .subscribe((response) => {
                      let path = response.relativePath.split('/');
                      let name = path[path.length - 1];
                      if (!this.files.includes(name)) {
                        this.files.push(name);
                        this.filesChange.emit(this.files);
                        this.fileError = '';
                      } else {
                        this.fileError = 'A file was overwritten!';
                      }
                    });
                } else {
                  this.uploadDAO
                    .uploadVesselFileSecure(
                      resized,
                      resized.name,
                      this.paramId,
                      this.s3path,
                    )
                    .subscribe((response) => {
                      let path = response.relativePath.split('/');
                      let name = path[path.length - 1];
                      if (!this.files.includes(name)) {
                        this.files.push(name);
                        this.filesChange.emit(this.files);
                        this.fileError = '';
                      } else {
                        this.fileError = 'A file was overwritten!';
                      }
                    });
                }
              },
            );
          } else {
            if (!this.vesselForm) {
              this.uploadDAO
                .uploadFileSecure(
                  files.item(i),
                  files.item(i).name,
                  this.paramId,
                  this.s3path,
                )
                .subscribe((response) => {
                  let path = response.relativePath.split('/');
                  let name = path[path.length - 1];
                  if (!this.files.includes(name)) {
                    this.files.push(name);
                    this.filesChange.emit(this.files);
                    this.fileError = '';
                  } else {
                    this.fileError = 'A file was overwritten!';
                  }
                });
            } else {
              this.uploadDAO
                .uploadVesselFileSecure(
                  files.item(i),
                  files.item(i).name,
                  this.paramId,
                  this.s3path,
                )
                .subscribe((response) => {
                  let path = response.relativePath.split('/');
                  let name = path[path.length - 1];
                  if (!this.files.includes(name)) {
                    this.files.push(name);
                    this.filesChange.emit(this.files);
                    this.fileError = '';
                  } else {
                    this.fileError = 'A file was overwritten!';
                  }
                });
            }
          }
        } else {
          this.fileError =
            'Error uploading file.  Supported file types are: .pdf, .png, and .jpg';
        }
      }
    }

    event.target.value = '';
  }

  downloadFile(index: number) {
    let key = this.keyPrefix + this.files[index];
    this.uploadDAO.downloadFile(key, this.paramId).subscribe(
      (result) => {
        let type;
        let ext = this.files[index].split('.').pop();
        if (ext === 'pdf') {
          type = 'application/pdf';
        } else if (ext === 'jpg') {
          type = 'image/jpeg';
        } else if (ext === 'png') {
          type = 'image/png';
        } else {
          type = '';
        }
        let file = new File([result], this.files[index], {
          type: type,
        });
        // FileSaver.saveAs(file);
      },
      (err) => {
        console.error(err);
      },
    );
  }
}
